module.exports = __webpack_public_path__ + "static/media/enviar.eb299650.svg";